import { BaseBlock } from "../BaseBlock";

import type { SubscriptionChangeActions }
    from "../../screens/components/SubscriptionChangeActions";
import type { HeaderEvents }
    from "../../screens/components/HeaderEvents"; 

export class ConfirmSubscriptionActionsBlock
    extends BaseBlock {

    private readonly actions:
        SubscriptionChangeActions;
    private readonly headerEvents:
    HeaderEvents;    

    private readonly subscriptionId: string;

    private readonly stickerId:
        string;


    constructor(
        subscriptionId: string,
        stickerId: string,
        actions: SubscriptionChangeActions,
        headerEvents: HeaderEvents
    ) {

        super();

        this.subscriptionId =
            subscriptionId;

        this.stickerId =
            stickerId;

        this.actions =
            actions;

        this.headerEvents =
            headerEvents;

    }

    public override mount(): void {

        super.mount();

        const root =
            document.createElement("section");

        root.className =
            "confirm-subscription-actions";

        // =====================================================
        // Підтвердити
        // =====================================================

        const confirm =
            document.createElement("button");

        confirm.className =
            "primary-button";

        confirm.textContent =
            "Підтвердити зміну підписки";

        confirm.onclick = () => {

            this.actions.confirmSubscriptionChange(

                this.subscriptionId,

                this.stickerId

            );

        };

        root.appendChild(
            confirm
        );

        // =====================================================
        // Скасувати
        // =====================================================

        const cancel =
            document.createElement("button");

        cancel.className =
            "secondary-button";

        cancel.textContent =
            "Скасувати";

        cancel.onclick = () => {

            this.headerEvents.backClicked();

        };

        root.appendChild(
            cancel
        );

        this.root = root;

    }

}